import { render } from "./NeedSubscription.header.vue?vue&type=template&id=20692a3d"
import script from "./NeedSubscription.header.vue?vue&type=script&lang=js"
export * from "./NeedSubscription.header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__